import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material"
import { useGetChatAnalysesQuery } from "../../store/chatAnalyzeApi"
import type { ChatAnalyze } from "../interfaces"

const SOURCE_LABELS: Record<ChatAnalyze.AnalysisSource, string> = {
  manual: "ручной",
  "guest-bot": "авто",
}

interface AnalysisVersionSelectProps {
  chatId: string
  selectedAnalysisId: string | null
  onChange: (analysisId: string) => void
  /** Фильтр истории по источнику (§1.2); undefined = без фильтра. */
  source?: string
}

export function AnalysisVersionSelect({
  chatId,
  selectedAnalysisId,
  onChange,
  source,
}: AnalysisVersionSelectProps) {
  const { data: analyses = [] } = useGetChatAnalysesQuery({
    chatId,
    source,
  })

  // Hidden when there is only one version — no choice to make
  if (analyses.length <= 1) return null

  const handleChange = (e: SelectChangeEvent) => onChange(e.target.value)

  const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })

  return (
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel>Версия анализа</InputLabel>
      <Select
        value={selectedAnalysisId ?? ""}
        label="Версия анализа"
        onChange={handleChange}
      >
        {analyses.map((a: ChatAnalyze.AnalysisSummary, idx: number) => (
          <MenuItem key={a.id} value={a.id}>
            {formatDate(a.analyzedAt)}
            {idx === 0 ? " (последний)" : ""}
            {" · "}
            {a.totalMessages.toLocaleString("ru-RU")} сообщ.
            {" · "}
            <Chip
              size="small"
              variant="outlined"
              label={SOURCE_LABELS[a.source]}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
